import { render, staticRenderFns } from "./SMRecievedRequests.vue?vue&type=template&id=1f4115fe&"
import script from "./SMRecievedRequests.vue?vue&type=script&lang=js&"
export * from "./SMRecievedRequests.vue?vue&type=script&lang=js&"
import style0 from "./SMRecievedRequests.vue?vue&type=style&index=0&id=1f4115fe&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports